/**
 * LSCMonogram \u2014 monogram-only mark.
 *
 * The site's `BrandMark` component now renders the full brand lockup
 * (monogram + wordmark + tagline as one stacked artwork). To avoid
 * double-rendering the monogram wherever this component sits next to a
 * BrandMark (Navbar, Footer), this component now renders NOTHING by
 * default. Where a standalone monogram is still needed (StarSpinner
 * fallback, About-page constellation, favicon), consumers can opt in
 * with `standalone`.
 *
 * Props:
 *   size        \u2014 pixel height
 *   standalone  \u2014 render the monogram-only artwork (default false)
 *   className   \u2014 extra utility classes
 *   tone        \u2014 kept for backwards compat (ignored; artwork is fixed palette)
 */
const MONOGRAM_ASPECT = 1536 / 1024; // width / height of the source PNG

export default function LSCMonogram({
  size = 48,
  standalone = false,
  className = "",
  tone = "navy",
}) {
  void tone;
  if (!standalone) return null;
  const width = Math.round(size * MONOGRAM_ASPECT);
  return (
    <img
      src="/brand/lsc-monogram.png"
      width={width}
      height={size}
      alt="LSC \u2014 Lone Star Counsel"
      className={`inline-block object-contain ${className}`}
      style={{ height: size, width }}
      loading="eager"
    />
  );
}
